<template>
  <div class="update-mlbb-mmr-wrapper">
    <div v-if="isLoading" class="text-muted">Загружаем текущий рейтинг…</div>

    <template v-else>
      <h5>
        Игрок <b>{{ params.username }}</b>
      </h5>

      <!-- 404 от ручки: MLBB ID не привязан, править нечего. -->
      <b-alert v-if="!current" show variant="warning" class="mt-3">
        У игрока не привязан MLBB ID — рейтинга нет и установить его нельзя.
      </b-alert>

      <template v-else>
        <table class="table mt-3 mb-4">
          <tr>
            <th>Текущий MMR</th>
            <td>{{ current.mmr }}</td>
          </tr>
          <tr>
            <th>Дивизион</th>
            <td>{{ current.division }}</td>
          </tr>
          <tr>
            <th>Последний матч</th>
            <td>{{ lastMatchLabel }}</td>
          </tr>
        </table>

        <b-form-group label="Новое значение MMR" label-class="font-weight-bold">
          <b-input v-model="formModel.mmr"
                   type="number"
                   min="0"
                   max="100000"
                   placeholder="520"/>
        </b-form-group>

        <b-form-group label="Причина" label-class="font-weight-bold">
          <b-textarea v-model="formModel.comment"
                      rows="3"
                      maxlength="500"
                      placeholder="Корректировка после разбора жалобы"/>
          <small class="text-muted">{{ formModel.comment.length }} / 500</small>
        </b-form-group>

        <footer>
          <b-button variant="primary" :disabled="!isValid || isSaving" @click="submitForm">
            {{ isSaving ? 'Сохраняем...' : 'Установить MMR' }}
          </b-button>
        </footer>
      </template>
    </template>

    <b-alert v-if="errorText" show variant="danger" style="margin: 10px 0 0 0">{{ errorText }}</b-alert>
  </div>
</template>

<script>
import api from "@/api/api";
import moment from "moment";

export default {
  name: "UpdateMlbbMmr",
  props: {
    params: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isLoading: false,
      isSaving: false,
      errorText: null,
      current: null,
      formModel: {
        mmr: '',
        comment: ''
      }
    }
  },
  computed: {
    lastMatchLabel() {
      if (!this.current?.last_match_at) return 'матчей ещё не было'
      return moment(this.current.last_match_at).format('DD.MM.YYYY HH:mm')
    },
    /**
     * Оба поля обязательны: значение 0–100000, причина до 500 символов.
     * Пустой MMR отличаем от нуля явно — 0 это допустимое значение.
     */
    isValid() {
      const mmr = Number(this.formModel.mmr)
      if (this.formModel.mmr === '' || !Number.isInteger(mmr)) return false
      if (mmr < 0 || mmr > 100000) return false
      return !!this.formModel.comment.trim()
    }
  },
  methods: {
    async loadCurrent() {
      this.isLoading = true
      this.errorText = null
      try {
        const res = await api.mlbbMmr.show(this.params.userId)
        this.current = res?.data?.data ?? null
        if (this.current) this.formModel.mmr = this.current.mmr
      } catch (e) {
        // 404 — нет привязанного MLBB ID, это штатное состояние, а не сбой.
        if (e?.response?.status !== 404) {
          this.errorText = e?.response?.data?.message || 'Не удалось загрузить текущий рейтинг'
        }
      } finally {
        this.isLoading = false
      }
    },
    async submitForm() {
      if (!this.isValid) return
      this.isSaving = true
      this.errorText = null
      try {
        await api.mlbbMmr.update(this.params.userId, {
          mmr: Number(this.formModel.mmr),
          comment: this.formModel.comment.trim()
        })
        this.$toast.success('MMR обновлён')
        this.$emit('submit')
        this.$emit('closeModal')
      } catch (e) {
        const data = e?.response?.data
        let errors = ''
        if (data?.errors) {
          errors = Object.entries(data.errors)
              .map(([name, values]) => `${name}: ${values.join(', ')}`)
              .join('. ')
        }
        const message = data?.message || e?.message || 'Не удалось установить MMR'
        this.errorText = errors ? `${message}; ${errors}.` : message
      } finally {
        this.isSaving = false
      }
    }
  },
  created() {
    this.loadCurrent()
  }
}
</script>

<style scoped lang="scss">
.update-mlbb-mmr-wrapper {
  footer {
    text-align: right;
  }
}
</style>
